import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type RootState } from '../../../app/store'

export const KYC_ARCHIVE_PAGE_SIZE = 25

export interface KycArchiveState {
  searchText: string
  page: number
  pageSize: number
  currentApplicationId: string | null
  tabIndex: number
}

const initialState: KycArchiveState = {
  searchText: '',
  page: 0,
  pageSize: KYC_ARCHIVE_PAGE_SIZE,
  currentApplicationId: null,
  tabIndex: 0
}

export const kycArchiveSlice = createSlice({
  name: 'kycArchive',
  initialState,
  reducers: {
    setSearchText: (state, action: PayloadAction<string>) => {
      state.searchText = action.payload
      state.page = 0
    },
    setDataGridPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload
    },
    setCurrentApplicationId: (state, action: PayloadAction<string | null>) => {
      state.currentApplicationId = action.payload
    },
    setTabIndex: (state, action: PayloadAction<number>) => {
      state.tabIndex = action.payload
    },
    resetKycArchiveApplication: (state) => {
      state.currentApplicationId = null
      state.tabIndex = 0
    }
  }
})

export const {
  setSearchText,
  setDataGridPage,
  setCurrentApplicationId,
  setTabIndex,
  resetKycArchiveApplication
} = kycArchiveSlice.actions

export const selectSearchText = (state: RootState): string => state.kycArchive.searchText
export const selectDataGridPage = (state: RootState): number => state.kycArchive.page
export const selectPageSize = (state: RootState): number => state.kycArchive.pageSize
export const selectCurrentApplicationId = (state: RootState): string | null => state.kycArchive.currentApplicationId
export const selectTabIndex = (state: RootState): number => state.kycArchive.tabIndex

export default kycArchiveSlice.reducer
